"use client";

import { ReactNode } from "react";

export interface NavItem {
  id: string;
  title: string;
  description?: string;
  icon?: ReactNode;
  isComplete?: boolean;
}

interface SidebarNavProps {
  items: NavItem[];
  activeId: string;
  onItemClick: (id: string) => void;
  className?: string;
}

export const SidebarNav = ({
  items,
  activeId,
  onItemClick,
  className = ''
}: SidebarNavProps) => {
  return (
    <nav className={`space-y-2 ${className}`}>
      {items.map((item) => {
        const isActive = activeId === item.id;
        
        return (
          <button
            key={item.id}
            onClick={() => onItemClick(item.id)}
            className={`
              w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors
              ${isActive 
                ? 'bg-gray-50 text-gray-900 border border-gray-200' 
                : 'hover:bg-gray-50 text-gray-700'
              }
            `}
          >
            {item.icon && (
              <div className={`flex-shrink-0 ${isActive ? 'text-primary-600' : 'text-gray-400'}`}>
                {item.icon}
              </div>
            )}
            <div className="flex-1 text-left">
              <div className="font-medium">{item.title}</div>
              {item.description && (
                <div className="text-xs text-gray-500">{item.description}</div>
              )}
            </div>
            {item.isComplete !== undefined && (
              <div className="flex-shrink-0">
                {item.isComplete ? (
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                    <svg className="w-4 h-4 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                ) : (
                  <div className="w-6 h-6 border-2 border-gray-300 rounded-full" />
                )}
              </div>
            )}
          </button>
        );
      })}
    </nav>
  );
};